module.exports = __webpack_public_path__ + "a903975c8197a9bd14f1820f64bc1843.svg";